import { createPermissionChecker } from '@/router/iot/helper';
import { hasTemporaryStaffAccessCreatePermission } from '@/router/iot/access/_staff_access';

export default [
    {
        routeName: 'iot.group-access.index',
        items: [
            {
                title: 'add location',
                routeName: 'iot.group-access.add-location',
                allowed: createPermissionChecker('GROUP_USER_ACCESS_READ_LIST'),
            },
        ],
    },
    {
        routeName: 'iot.staff-access.index',
        items: [
            {
                title: 'expired/revoked access',
                routeName: 'iot.staff-access.expired-revoked-access',
                allowed: createPermissionChecker('TEMPORARY_USER_ACCESS_READ_LIST'),
            },
            {
                title: 'event log',
                routeName: 'iot.staff-access.event-log',
                allowed: createPermissionChecker('LOCK_READ_VIRTUAL_HISTORY_LOG'),
            },
            {
                title: 'grant access',
                routeName: 'iot.staff-access.grant-access',
                allowed: hasTemporaryStaffAccessCreatePermission,
            },
        ],
    },
    {
        routeName: 'iot.firekey.index',
        items: [
            {
                title: 'key management',
                routeName: 'iot.firekey.management',
                allowed: createPermissionChecker('LOCK_ISSUE_KEY_CREDENTIALS'),
            },
        ],
    },
    {
        routeName: 'iot.keys.index',
        items: [
            {
                title: 'add keys',
                routeName: 'iot.keys.create',
                allowed: createPermissionChecker('LOCK_CREATE_KEY_CREDENTIALS'),
            },
            {
                title: 'import keys from csv',
                routeName: 'iot.keys.import',
                allowed: createPermissionChecker('LOCK_IMPORT_KEY_CREDENTIALS'),
            },
            {
                title: 'assign keys',
                routeName: 'iot.keys.assign',
                allowed: createPermissionChecker('LOCK_ISSUE_KEY_CREDENTIALS'),
            },
            {
                title: 'delete keys',
                routeName: 'iot.keys.delete',
                allowed: createPermissionChecker('LOCK_DELETE_KEY_CREDENTIALS'),
            },
        ],
    },
    {
        routeName: 'iot.locations.index',
        items: [
            {
                title: 'create location',
                routeName: 'iot.locations.create',
                allowed: createPermissionChecker('LOCATION_CREATE'),
            },
        ],
    },
    {
        routeName: 'iot.units.index',
        items: [
            {
                title: 'add location',
                routeName: 'iot.locations.create',
                allowed: createPermissionChecker('LOCATION_CREATE'),
            },
        ],
    },
    {
        routeName: 'iot.apartments-list.index',
        items: [
            {
                title: 'add location',
                routeName: 'iot.locations.create',
                allowed: createPermissionChecker('LOCATION_CREATE'),
            },
        ],
    },
    {
        routeName: 'iot.locations.details',
        items: [
            {
                id: 'iot-location-delete',
                title: 'delete',
                showConfirmation: true,
                confirmationMessage: 'are you sure you want to delete this location?',
                confirmBtnText: 'yes, delete',
                cancelBtnText: 'no, go back',
                confirmationType: 'warning',
                allowed: createPermissionChecker('LOCATION_DELETE'),
            },
        ],
    },
    {
        routeName: 'iot.custom_group_access.index',
        items: [
            {
                title: 'add new group',
                routeName: 'iot.custom_group_access.create',
                allowed: createPermissionChecker('CUSTOM_USER_GROUP_CREATE'),
            },
        ],
    },
    {
        routeName: 'iot.custom_group_access.details',
        items: [
            {
                title: 'edit group',
                routeName: 'iot.custom_group_access.edit',
                params: {
                    id: '{id}',
                },
                allowed: createPermissionChecker('CUSTOM_USER_GROUP_UPDATE'),
            },
        ],
    },
    {
        routeName: 'iot.integration_queue.index',
        items: [
            {
                title: 'auto-apply settings',
                routeName: 'iot.integration_queue.auto_apply_settings',
                allowed: createPermissionChecker('EXT_COMMUNITY_EVENT_READ_CONFIG'),
            },
        ],
    },
    {
        routeName: 'iot.auto_open.index',
        items: [
            {
                title: 'add new',
                routeName: 'iot.auto_open.create',
                allowed: createPermissionChecker('PDK_AUTO_OPEN_CREATE'),
            },
        ],
    },
    {
        routeName: 'iot.integrated_community.details',
        items: [
            {
                title: 'download report',
                isDownload: true,
            },
        ],
    },
];
